<template>
  <InfoPanel class="sidebar-panel" height="auto">
    <template #content>
      <div v-if="$route.params.id && !$route.params.rateId">
        <!-- NOME DO HOTEL -->
        <PmwHeading
          size="paragraph-80"
          weight="weight-medium"
          class="sidebar-panel--name"
        >
          {{ hotelData?.nome }}
        </PmwHeading>
      </div>

      <!-- PAINEL NO CASO DE EDIÇÃO -->
      <div v-if="$route.params.rateId" class="sidebar-panel">
        <!-- INFORMAÇÃO SOBRE CRIAÇÃO -->
        <div v-if="$route.params.id">
          <!-- NOME DO HOTEL -->
          <PmwHeading class="sidebar-panel--name">
            {{ hotelData?.nome }}
          </PmwHeading>
        </div>

        <div v-if="fluctuationData.usuarioInclusao" name="created">
          <PmwHeading class="sidebar-panel--title">
            Criado por
          </PmwHeading>
          <PmwParagraph class="sidebar-panel--info">
            {{ fluctuationData.usuarioInclusao }},
            {{ formatDate(new Date(fluctuationData.dataInclusao)) }}
          </PmwParagraph>
        </div>

        <!-- INFORMAÇÃO SOBRE EDIÇÃO -->
        <div v-if="fluctuationData.usuarioAlteracao" name="edited">
          <PmwHeading class="sidebar-panel--title">
            Ultima alteração por
          </PmwHeading>
          <PmwParagraph class="sidebar-panel--info">
            {{ fluctuationData.usuarioAlteracao }},
            {{ formatDate(new Date(fluctuationData.dataAlteracao)) }}
          </PmwParagraph>
        </div>
      </div>
    </template>
  </InfoPanel>
</template>

<script>
import InfoPanel from '@solucoes/components-lib-tmp/src/components/patterns/InfoPanel'
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import { formatDate } from '@/helpers/date'

export default {
  name: 'SidebarPanel',
  components: {
    InfoPanel,
    PmwHeading,
    PmwParagraph
  },

  props: {
    fluctuationData: {
      type: Object,
      default: () => ({})
    },

    hotelData: {
      type: Object,
      default: () => ({})
    }
  },

  methods: {
    formatDate: formatDate
  }
}
</script>

<style lang="scss" scoped>
.sidebar-panel {
  gap: 8px;
  display: grid;

  &--name {
    text-align: center;
    line-height: 21px;
    font-size: font-size('size-large');
  }

  &--title {
    margin-bottom: 6px;
    font-size: font-size('size-medium');
  }

  &--info {
    margin-bottom: 16px;
    font-size: font-size('size-medium');
  }
}
</style>
